import'setimmediate';if(typeof global.requestAnimationFrame==='undefined'){global.requestAnimationFrame=setImmediate;}